import { MouseEvent } from 'react';

import { isGoogleDocUrl } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

export const isSafeUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
};

export const isExternalLink = (uri: string): boolean =>
  /^https?:\/\//i.test(uri);

export const isExternalDocument = (uri: string): boolean =>
  uri.replace(/^\/\//, '').startsWith('externalDocuments/');

export const isCollaborativeDocument = (uri: string): boolean =>
  uri.replace(/^\/\//, '').startsWith('collaborativeDocuments/');

export const isContextArtifact = (artifact: AttachmentFragment): boolean =>
  isExternalLink(artifact.uri) || isExternalDocument(artifact.uri);

export const isRenamableArtifact = (artifact: AttachmentFragment): boolean => {
  const { uri } = artifact;
  if (isGoogleDocUrl(uri)) return false;
  if (isExternalLink(uri)) return true;
  if (isExternalDocument(uri)) return true;
  if (isCollaborativeDocument(uri)) return true;
  return false;
};

export const createModifierClickHandler =
  (href: string | undefined, onSelect: () => void) => (event: MouseEvent) => {
    if ((event.metaKey || event.ctrlKey) && href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    onSelect();
  };
